// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_group":"news_group-QfJjepMb","news_group_title":"news_group_title-OXsdU_JJ","block":"block-3a-xfQDJ","link_title":"link_title-3aA52n29","more":"more-vBJIE_y6"};